var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAuthParrot = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 879,
    height: 515,
    viewBox: "0 0 879 515",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M812.171 510.68V440.677L761.594 390.106H4.25903",
    stroke: "#F4F4F4",
    strokeWidth: 7.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M423.78 337.289H811.706V4.2562",
    stroke: "#F4F4F4",
    strokeWidth: 7.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M828.159 234.994C828.159 313.712 764.41 377.525 685.772 377.525C607.133 377.525 543.384 313.712 543.384 234.994C543.384 156.277 607.133 92.4636 685.772 92.4636C764.41 92.4636 828.159 156.277 828.159 234.994Z",
    fill: "#FADB5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M591.852 277.445H504.795V180.003C504.795 162.415 519.046 148.158 536.626 148.158H591.852V277.445Z",
    fill: "#4A4A4A",
    fillOpacity: 0.06
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M583.241 265.385H496.184V167.943C496.184 150.356 510.435 136.099 528.015 136.099H583.241V265.385Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.127 165.386H567.651V169.693H515.127V165.386ZM515.127 234.298H567.651V238.605H515.127V234.298ZM515.127 220.516H567.651V224.823H515.127V220.516ZM515.127 211.902H567.651V216.209H515.127V211.902ZM515.127 177.446H567.651V181.753H515.127V177.446Z",
    fill: "#F0F0F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M745.035 342.523H626.508C624.173 342.523 622.28 340.152 622.28 337.227C622.28 334.301 624.173 331.93 626.508 331.93H745.035C747.37 331.93 749.263 334.301 749.263 337.227C749.263 340.152 747.37 342.523 745.035 342.523Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M754.356 306.907C756.3 304.961 756.3 301.806 754.356 299.86L718.865 264.334C718.347 263.815 717.507 263.815 716.989 264.334L705.493 275.841C704.975 276.36 704.975 277.201 705.493 277.72L734.651 306.907C740.092 312.354 748.915 312.354 754.356 306.907Z",
    fill: "#007CD2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M795.694 263.143C797.639 261.197 797.64 258.043 795.696 256.098L760.206 220.593C759.688 220.074 758.848 220.075 758.329 220.594L746.827 232.101C746.308 232.62 746.307 233.46 746.826 233.979L775.984 263.149C781.425 268.593 790.25 268.59 795.694 263.143Z",
    fill: "#0091E2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M806.344 296.191C809.121 293.411 809.121 288.904 806.344 286.125L731.475 211.18L698.522 244.165L750.495 296.191C765.917 311.629 790.922 311.629 806.344 296.191Z",
    fill: "#11ACEF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M795.602 285.438C798.379 282.659 798.379 278.152 795.602 275.372L720.733 200.427L687.78 233.413L739.753 285.438C755.175 300.876 780.18 300.876 795.602 285.438Z",
    fill: "#007CD2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M707.054 336.709C703.574 336.709 700.753 333.886 700.753 330.402V304.427C700.753 300.943 703.574 298.12 707.054 298.12C710.533 298.12 713.354 300.943 713.354 304.427V330.402C713.354 333.886 710.533 336.709 707.054 336.709Z",
    fill: "#343432"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M733.347 338.237C732.986 338.237 732.62 338.207 732.252 338.142C732.172 338.128 723.962 336.709 716.382 336.709C708.047 336.709 700.694 338.108 700.621 338.122C697.208 338.78 693.902 336.544 693.242 333.127C692.581 329.709 694.81 326.402 698.223 325.739C698.569 325.672 706.787 324.096 716.382 324.096C725.083 324.096 734.05 325.652 734.427 325.718C737.854 326.32 740.146 329.588 739.545 333.019C739.009 336.081 736.349 338.237 733.347 338.237Z",
    fill: "#343432"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M639.01 338.238C636.054 338.238 633.417 336.145 632.832 333.132C632.169 329.713 634.4 326.403 637.816 325.739C638.161 325.672 646.379 324.096 655.974 324.096C664.675 324.096 673.642 325.652 674.019 325.718C677.447 326.319 679.738 329.588 679.137 333.019C678.536 336.449 675.272 338.742 671.844 338.142C671.764 338.128 663.554 336.709 655.974 336.709C647.578 336.709 640.29 338.107 640.218 338.12C639.812 338.199 639.408 338.238 639.01 338.238Z",
    fill: "#343432"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M665.303 336.709C661.823 336.709 659.002 333.886 659.002 330.402V304.427C659.002 300.943 661.823 298.12 665.303 298.12C668.782 298.12 671.603 300.943 671.603 304.427V330.402C671.603 333.886 668.782 336.709 665.303 336.709Z",
    fill: "#343432"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.593 234.994C608.593 277.662 643.147 312.251 685.772 312.251C728.397 312.251 762.951 277.662 762.951 234.994C762.951 192.327 728.397 157.738 685.772 157.738C643.147 157.738 608.593 192.327 608.593 234.994Z",
    fill: "#0091E2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M668.131 153.236L647.054 168.149L658.05 171.612L677.266 163.414L668.131 153.236Z",
    fill: "#007CD2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M735.961 73.8697C734.309 72.2167 731.632 72.2167 729.98 73.8697L699.837 104.044C699.397 104.484 699.397 105.199 699.837 105.64L709.601 115.414C710.041 115.854 710.755 115.854 711.195 115.414L735.961 90.6221C740.582 85.9961 740.582 78.4956 735.961 73.8697Z",
    fill: "#007CD2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M747.563 97.7768C747.563 95.4389 745.67 93.5438 743.335 93.5438H700.705C700.082 93.5438 699.578 94.049 699.578 94.6721V108.494C699.578 109.117 700.082 109.623 700.705 109.623H735.729C742.265 109.623 747.563 104.319 747.563 97.7768Z",
    fill: "#0091E2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M658.05 91.1154C681.712 91.1154 700.893 110.315 700.893 134.001H615.208C615.208 110.315 634.389 91.1154 658.05 91.1154Z",
    fill: "#FAB13E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M662.16 149.122C653.817 149.122 647.054 142.352 647.054 134.001H677.266C677.266 142.352 670.503 149.122 662.16 149.122Z",
    fill: "#F69418"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M668.131 92.4183C675.29 88.0465 683.702 85.5264 692.702 85.5264C718.799 85.5264 739.955 106.703 739.955 132.826C739.955 158.949 718.799 180.126 692.702 180.126C683.702 180.126 675.29 177.606 668.131 173.235V92.4183Z",
    fill: "#007CD2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M668.131 102.155C673.582 97.2038 680.818 94.1867 688.759 94.1867C705.718 94.1867 719.467 107.949 719.467 124.926C719.467 141.902 705.718 155.665 688.759 155.665C680.818 155.665 673.582 152.648 668.131 147.696V102.155Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680.416 108.23C684.483 108.23 687.78 111.531 687.78 115.601C687.78 116.994 687.387 118.291 686.717 119.402C686.446 119.372 686.171 119.353 685.891 119.353C683.216 119.353 680.88 120.786 679.591 122.923C675.913 122.512 673.052 119.392 673.052 115.601C673.052 111.531 676.349 108.23 680.416 108.23Z",
    fill: "#343432"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M698.372 134.001C698.372 138.529 694.706 142.199 690.182 142.199C685.658 142.199 681.991 138.529 681.991 134.001C681.991 129.473 685.658 125.802 690.182 125.802C694.706 125.802 698.372 129.473 698.372 134.001Z",
    fill: "#FFDFE0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M729.705 259.405C732.209 259.405 734.462 258.362 736.078 256.695V263.283C736.078 266.807 733.225 269.663 729.705 269.663C726.185 269.663 723.331 266.807 723.331 263.283V256.695C724.947 258.362 727.201 259.405 729.705 259.405ZM716.958 271.275C719.462 271.275 721.715 270.231 723.331 268.564V275.153C723.331 278.676 720.478 281.532 716.958 281.532C713.438 281.532 710.585 278.676 710.585 275.153V268.565C712.201 270.232 714.454 271.275 716.958 271.275Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M814.285 107.072L794.224 127.154L779.523 112.437L807.129 84.8018C809.105 82.8241 812.309 82.8241 814.285 84.8018C820.429 90.9515 820.429 100.922 814.285 107.072Z",
    fill: "#11ACEF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M821.119 129.703L801.058 149.785L786.357 135.068L813.964 107.433C815.94 105.455 819.144 105.455 821.119 107.433C827.263 113.583 827.263 123.554 821.119 129.703Z",
    fill: "#11ACEF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M826.286 153.823L806.224 173.904L791.523 159.188L819.13 131.552C821.106 129.575 824.31 129.575 826.286 131.552V131.553C832.429 137.702 832.429 147.673 826.286 153.823Z",
    fill: "#11ACEF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M789.712 102.504L689.92 202.397C717.477 229.982 762.155 229.982 789.712 202.397C817.269 174.812 817.269 130.089 789.712 102.504Z",
    fill: "#0091E2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M778.264 179.003C776.493 177.231 774.163 176.374 771.843 176.408L776.497 171.75C778.986 169.258 783.021 169.258 785.51 171.75C787.999 174.241 787.999 178.28 785.51 180.772L780.856 185.431C780.89 183.108 780.034 180.775 778.264 179.003ZM777.635 161.588C775.865 159.815 773.534 158.958 771.214 158.993L775.868 154.334C778.356 151.843 782.392 151.843 784.881 154.334C787.37 156.825 787.37 160.865 784.881 163.357L780.227 168.015C780.262 165.693 779.405 163.36 777.635 161.588ZM754.892 166.309C753.122 164.536 750.791 163.679 748.471 163.714L753.125 159.055C755.613 156.564 759.649 156.564 762.138 159.055C764.627 161.546 764.627 165.586 762.138 168.078L757.484 172.736C757.519 170.414 756.662 168.081 754.892 166.309Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M542.42 204.75H570.791V183.938H531.748C528.953 183.938 526.688 186.206 526.688 189.003C526.688 197.7 533.731 204.75 542.42 204.75Z",
    fill: "#11ACEF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M553.13 225.562H581.501V204.75H542.459C539.664 204.75 537.399 207.018 537.399 209.815C537.399 218.512 544.442 225.562 553.13 225.562Z",
    fill: "#11ACEF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M566.991 246.374H595.362V225.562H556.319C553.525 225.562 551.26 227.83 551.26 230.627C551.26 239.324 558.303 246.374 566.991 246.374Z",
    fill: "#11ACEF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M627.494 254.573C588.522 254.573 556.93 222.949 556.93 183.938H698.057C698.057 222.949 666.465 254.573 627.494 254.573Z",
    fill: "#0091E2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.948 163.311C685.293 174.743 705.303 202.528 705.303 234.994C705.303 267.461 685.293 295.246 656.948 306.678C628.602 295.246 608.593 267.461 608.593 234.994C608.593 202.528 628.602 174.743 656.948 163.311Z",
    fill: "#007CD2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M691.571 198.031L724.105 168.159L710.2 168.898L671.861 163.311L659.292 169.575L691.571 198.031Z",
    fill: "#007CD2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M666.68 234.239C669.184 234.239 671.437 233.195 673.053 231.528V238.117C673.053 241.64 670.2 244.497 666.68 244.497C663.16 244.497 660.306 241.64 660.306 238.117V231.528C661.922 233.195 664.176 234.239 666.68 234.239ZM653.933 246.108C656.437 246.108 658.69 245.065 660.306 243.398V249.986C660.306 253.51 657.453 256.366 653.933 256.366C650.413 256.366 647.56 253.51 647.56 249.986V243.398C649.176 245.065 651.429 246.108 653.933 246.108ZM641.186 226.672C643.69 226.672 645.943 225.628 647.559 223.962V230.55C647.559 234.074 644.706 236.93 641.186 236.93C637.666 236.93 634.812 234.074 634.812 230.55V223.962C636.429 225.628 638.682 226.672 641.186 226.672Z",
    fill: "black",
    fillOpacity: 0.1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAuthParrot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/authParrot.d8215ef12211170816c9f522e543f6bb.svg";